import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceListOnlineOptionsProduct } from '../../../models/pricelist-online-options-product.model';
import { TableModule } from 'primeng/table';
import { PriceListCurrencyPrice } from '../../../models/pricelist-currency-price.model';

@Component({
  selector: 'lx-price-lists-portal-pricelist-online-options-product',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './pricelist-online-options-product.component.html',
  styleUrls: ['./pricelist-online-options-product.component.scss', './print-pricelist-online-options-product.component.scss'],
})
export class PricelistOnlineOptionsProductComponent implements OnChanges {
  @Input() dataSource: PriceListOnlineOptionsProduct[] | undefined;
  @Input() tableTitle: string | undefined;

  priceList: { name: string; prices: PriceListCurrencyPrice[] }[] = [];

  ngOnChanges({ dataSource }: SimpleChanges): void {
    if (dataSource && dataSource.currentValue) {
      this.priceList = (dataSource.currentValue as PriceListOnlineOptionsProduct[])
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((priceList) => ({ name: priceList?.name, prices: priceList?.options[0]?.prices }));
    }
  }
}
